<template>
  <div class="recommend" ref="container">
    <div class="title acea-row row-center-wrapper">
      <span class="iconfont icon-zhuangshixian"></span>
      <span class="name">为你推荐</span>
      <span class="iconfont icon-zhuangshixian lefticon"></span>
    </div>
    <div class="productList">
    <div
      class="list acea-row row-between-wrapper"
      :class="Switch === true ? '' : 'on'"
      ref="container"
    >
      <div
        @click="goDetail(item)"
        v-for="(item, index) in hostProduct"
        :key="index"
        class="item"
        :class="Switch === true ? '' : 'on'"
        :title="item.store_name"
      >
        <div class="pictrue" :class="Switch === true ? '' : 'on'">
          <img :src="item.image" :class="Switch === true ? '' : 'on'" />
          <span
            class="pictrue_log_class"
            :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'"
            v-if="item.activity && item.activity.type === '1'"
            >秒杀</span
          >
          <span
            class="pictrue_log_class"
            :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'"
            v-if="item.activity && item.activity.type === '2'"
            >砍价</span
          >
          <span
            class="pictrue_log_class"
            :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'"
            v-if="item.activity && item.activity.type === '3'"
            >拼团</span
          >
        </div>
        <div class="text" :class="Switch === true ? '' : 'on'">
          <div class="name line1">{{ item.store_name }}</div>
          <div
            class="name line1"
            style="color:#999999;font-size:12px;height:20px;line-height:20px"
          >
            {{ item.store_info }}
          </div>
          <!-- <div
                        class="money font-color-red"
                        :class="Switch === true ? '' : 'on'"
                    >
                        ￥<span class="num">{{ item.price }}</span>
                    </div> -->
          <!-- <div
                        class="vip acea-row row-between-wrapper"
                        :class="Switch === true ? '' : 'on'"
                    >
                        <div
                            class="vip-money"
                            v-if="item.vip_price && item.vip_price > 0"
                        >
                            ￥{{ item.vip_price
                            }}<img src="@assets/images/vip.png" />
                        </div>
                        <div>已售{{ item.sales }}件</div>
                    </div> -->
          <div class="go-shop">
            <div
              class="money font-color-red row-flex"
              :class="Switch === true ? '' : 'on'"
            >
              ￥<span class="num">{{ item.price }}</span>
              <div class="span row-flex" v-if="item.gains!=0">
              <img src="@assets/images/icon_up.png" alt=""  v-if="item.gains==1"/>
              <img src="@assets/images/icon_down.png" alt="" v-if="item.gains==2" />
              <div style="color:#D01112">{{item.gains_num}}%</div>
            </div>
            </div>
            
            
          </div>
          <div class="go">
              立即购买
            </div>
        </div>
      </div>
    </div>
    </div>
    <Loading :loaded="loadend" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getHostProducts } from "@api/store";
import Loading from "@components/Loading";
import { goShopDetail } from "@libs/order";
export default {
  name: "Recommend",
  props: {},
  components: {
    Loading
  },
  data: function() {
    return {
      hostProduct: [],
      page: 1,
      limit: 20,
      loadTitle: "",
      Switch: true,
      loading: false,
      loadend: false
    };
  },
  mounted: function() {
    this.hostProducts();
    this.$scroll(this.$refs.container.parentElement, () => {
      !this.loading && this.hostProducts();
    });
  },
  methods: {
    // 商品详情跳转
    goDetail(item) {
      goShopDetail(item).then(() => {
        this.$router.push({ path: "/detail/" + item.id });
      });
    },
    hostProducts: function() {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      getHostProducts(that.page, that.limit).then(res => {
        that.loading = false;
        //apply();js将一个数组插入另一个数组;
        that.hostProduct.push.apply(that.hostProduct, res.data);
        that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
        that.page = that.page + 1;
      });
    }
  }
};
</script>
<style scoped>
  .productList .search .input {
  background: rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
}
.productList .search .input input {
  color: #fff;
}
.productList .search .input ::placeholder {
  color: #fff;
}
.productList .search .input .iconfont {
  color: #fff;
}
.productList .list .item .pictrue {
  height: 194px;
}
.productList .list .item {
  height: 305px;
}
.go-shop {
  /* height: 33px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
}
 .go {
  width: 64px;
  height: 20px;
  background: #d01112;
  border-radius: 13px;
  line-height: 20px;
  color: #fff;
  background: #d01112;
  font-size: 12px;
  text-align: center;
  float:right;
}
.productList .list .item.on {
  height: 120px;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
  margin-bottom: 10px;
  padding: 0;
  display: flex;
  align-items: center;
}
.productList .list .item .pictrue.on {
  width: 110px;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.productList .list .item .pictrue img.on {
  width: 110px;
  height: 110px;
  margin-left: 6px;
}

.productList .list.on {
  margin-top: 1.92rem;
  background-color: #f8f8f8;
}
.productList .list {
    padding: 0 0.2rem;
    margin-top: 0;
}
.productList .list.on .name {
  padding-top: 4px;
}
.productList{
  background: #f5f5f5;
}
.productList .list .item .text.on {
  width: 4.68rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.productList .list .item.on .go-shop {
  width: 100%;
}
.productList .list .item .text .money.on {
  margin-top: 0;
}
.span{
  display: flex;
  align-items: center;
  margin-left:10px ;
}
.span img{
  width: 15px;
  height: 9px;
}
.span div{
  padding-left: 5px;
}
</style>